import React from "react";

const PasswordInput = ({ text, type, placeholder, preText, onTextChanged, onKeyDown, autocompleteMessage }) => {
  const handleChange = (e) => {
    onTextChanged(e.target.value);
  };

  return (
    <div className="tw-w-full">
      {preText && (
        <div className="tw-mb-1 tw-mt-2 tw-font-bold tw-text-left">
          {preText}
        </div>
      )}
      <input
        type={type}
        value={text}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        autoComplete={autocompleteMessage}
        className="tw-w-full tw-py-2 tw-px-3 tw-border tw-border-gray-300 tw-rounded-lg tw-text-center focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-400 tw-text-base"
      />
      <hr className="tw-w-5/6 tw-mt-2 tw-border-black" />
    </div>
  );
};

export default PasswordInput;
